(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfl-first-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bfl-first-order')) {
    class BflFirstOrder extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const input = this.querySelector('input');
        const status = this.querySelector('[data-status]');
        this.querySelector('[data-copy]').addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(input.value);
            status.textContent = status.dataset.success;
          } catch {
            input.focus();
            input.select();
            status.textContent = status.dataset.fallback;
          }
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    }
    customElements.define('bfl-first-order', BflFirstOrder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfl-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bfl-ugc-carousel')) {
    class BflUgcCarousel extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        const track = this.querySelector('.bfl-ugc__track');
        if (!track) return;
        const previous = this.querySelector('[data-previous]');
        const next = this.querySelector('[data-next]');
        const navigation = this.querySelector('.bfl-ugc__navigation');
        const hint = this.querySelector('.bfl-ugc__hint');
        const videos = [...this.querySelectorAll('video')];
        const update = () => {
          const overflow = track.scrollWidth > track.clientWidth + 4;
          navigation.hidden = !overflow;
          hint.hidden = !overflow;
          track.tabIndex = overflow ? 0 : -1;
          previous.disabled = track.scrollLeft <= 4;
          next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        };
        const move = direction => {
          const first = track.querySelector('.bfl-ugc__card');
          const step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
          track.scrollBy({ left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), { signal });
        next.addEventListener('click', () => move(1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        for (const video of videos) {
          const card = video.closest('.bfl-ugc__card');
          const play = card.querySelector('[data-play]');
          const error = card.querySelector('.bfl-ugc__error');
          play.hidden = false;
          play.addEventListener('click', async () => {
            for (const other of videos) if (other !== video) other.pause();
            error.hidden = true;
            try { await video.play(); } catch { error.hidden = false; }
          }, { signal });
          video.addEventListener('play', () => {
            for (const other of videos) if (other !== video) other.pause();
            play.hidden = true;
          }, { signal });
          video.addEventListener('pause', () => { play.hidden = false; }, { signal });
          video.addEventListener('ended', () => { play.hidden = false; }, { signal });
          video.addEventListener('error', () => { error.hidden = false; play.hidden = false; }, { signal });
        }
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) for (const video of videos) video.pause();
        }, { signal });
        if ('IntersectionObserver' in window) {
          this.intersections = new IntersectionObserver(entries => {
            for (const entry of entries) if (!entry.isIntersecting) entry.target.pause();
          }, { threshold: .2 });
          for (const video of videos) this.intersections.observe(video);
        }
        if ('ResizeObserver' in window) {
          this.resizes = new ResizeObserver(update);
          this.resizes.observe(track);
        } else window.addEventListener('resize', update, { signal });
        update();
      }
      disconnectedCallback() {
        for (const video of this.querySelectorAll('video')) video.pause();
        this.abort?.abort();
        this.abort = null;
        this.intersections?.disconnect();
        this.resizes?.disconnect();
      }
    }
    customElements.define('bfl-ugc-carousel', BflUgcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
